import { default as CoeJ3NwHU5OpYMeta } from "/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/Coe.vue?macro=true";
import { default as EnvironmentalSoundPr0RMANC1XMeta } from "/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/EnvironmentalSound.vue?macro=true";
import { default as Points8UzeVHmm1uMeta } from "/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/Points.vue?macro=true";
import { default as RecordTestIXTsb2XVqsMeta } from "/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/RecordTest.vue?macro=true";
import { default as TextS7IW1Q6YB2Meta } from "/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/Text.vue?macro=true";
import { default as Faqszv1PcBg7jMeta } from "/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Faq.vue?macro=true";
import { default as SigninGTdZF3QwQIMeta } from "/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Signin.vue?macro=true";
import { default as indexB9ncSHg0PZMeta } from "/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/index.vue?macro=true";
export default [
  {
    name: CoeJ3NwHU5OpYMeta?.name ?? "Create-Coe",
    path: CoeJ3NwHU5OpYMeta?.path ?? "/Create/Coe",
    meta: CoeJ3NwHU5OpYMeta || {},
    alias: CoeJ3NwHU5OpYMeta?.alias || [],
    redirect: CoeJ3NwHU5OpYMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/Coe.vue").then(m => m.default || m)
  },
  {
    name: EnvironmentalSoundPr0RMANC1XMeta?.name ?? "Create-EnvironmentalSound",
    path: EnvironmentalSoundPr0RMANC1XMeta?.path ?? "/Create/EnvironmentalSound",
    meta: EnvironmentalSoundPr0RMANC1XMeta || {},
    alias: EnvironmentalSoundPr0RMANC1XMeta?.alias || [],
    redirect: EnvironmentalSoundPr0RMANC1XMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/EnvironmentalSound.vue").then(m => m.default || m)
  },
  {
    name: Points8UzeVHmm1uMeta?.name ?? "Create-Points",
    path: Points8UzeVHmm1uMeta?.path ?? "/Create/Points",
    meta: Points8UzeVHmm1uMeta || {},
    alias: Points8UzeVHmm1uMeta?.alias || [],
    redirect: Points8UzeVHmm1uMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/Points.vue").then(m => m.default || m)
  },
  {
    name: RecordTestIXTsb2XVqsMeta?.name ?? "Create-RecordTest",
    path: RecordTestIXTsb2XVqsMeta?.path ?? "/Create/RecordTest",
    meta: RecordTestIXTsb2XVqsMeta || {},
    alias: RecordTestIXTsb2XVqsMeta?.alias || [],
    redirect: RecordTestIXTsb2XVqsMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/RecordTest.vue").then(m => m.default || m)
  },
  {
    name: TextS7IW1Q6YB2Meta?.name ?? "Create-Text",
    path: TextS7IW1Q6YB2Meta?.path ?? "/Create/Text",
    meta: TextS7IW1Q6YB2Meta || {},
    alias: TextS7IW1Q6YB2Meta?.alias || [],
    redirect: TextS7IW1Q6YB2Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Create/Text.vue").then(m => m.default || m)
  },
  {
    name: Faqszv1PcBg7jMeta?.name ?? "Faq",
    path: Faqszv1PcBg7jMeta?.path ?? "/Faq",
    meta: Faqszv1PcBg7jMeta || {},
    alias: Faqszv1PcBg7jMeta?.alias || [],
    redirect: Faqszv1PcBg7jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Faq.vue").then(m => m.default || m)
  },
  {
    name: SigninGTdZF3QwQIMeta?.name ?? "Signin",
    path: SigninGTdZF3QwQIMeta?.path ?? "/Signin",
    meta: SigninGTdZF3QwQIMeta || {},
    alias: SigninGTdZF3QwQIMeta?.alias || [],
    redirect: SigninGTdZF3QwQIMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/Signin.vue").then(m => m.default || m)
  },
  {
    name: indexB9ncSHg0PZMeta?.name ?? "index",
    path: indexB9ncSHg0PZMeta?.path ?? "/",
    meta: indexB9ncSHg0PZMeta || {},
    alias: indexB9ncSHg0PZMeta?.alias || [],
    redirect: indexB9ncSHg0PZMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src337157470/src/toppan-voice-recorder-frontend/pages/index.vue").then(m => m.default || m)
  }
]